<template>
  <div>
    <div class="row">
      <div class="col p-2 text-center">
        <div v-if="accounts">
          <select
            name="accounts"
            id="accounts"
            class="form-select text-center"
            v-model="currentAccountId"
            @change="accountChange($event.target.value)"
          >
            <option v-for="a in accounts" :value="a.Id" :key="a.Id">
              {{ a.Title }} ({{ a.WaitingJobCount }})
            </option>
          </select>
        </div>
        <div v-else>
          <span class="lead">{{ currentAccount.Title }}</span>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col m-2">
        <h1 class="text-center display-2">İşlerim</h1>
      </div>
    </div>

    <div
      class="row row-cols-2 row-cols-xs-2 row-cols-sm-1 row-cols-md-1 g-3"
      v-if="myStats"
    >
      <div class="col">
        <div
          class="card h-100 text-center text-white bg-primary"
          @click="goToJobPage('MyWaiting')"
        >
          <div class="card-body">
            <h2 class="card-title">{{ myStats.Waiting }}</h2>
            <p class="card-text">{{ getJobTypeText("MyWaiting") }}</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100 text-center" @click="goToJobPage('MyApproved')">
          <div class="card-body">
            <h2 class="card-title text-success">{{ myStats.Approved }}</h2>
            <p class="card-text">{{ getJobTypeText("MyApproved") }}</p>
          </div>
        </div>
      </div>
      <div class="col" v-if="hasAuth('Rem')">
        <div class="card h-100 text-center" @click="goToJobPage('Rem')">
          <div class="card-body">
            <h2 class="card-title text-secondary">{{ myStats.Rem }}</h2>
            <p class="card-text">{{ getJobTypeText("Rem") }}</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100 text-center" @click="goToJobPage('MyDeclined')">
          <div class="card-body">
            <h2 class="card-title text-danger">{{ myStats.Declined }}</h2>
            <p class="card-text">{{ getJobTypeText("MyDeclined") }}</p>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="card h-100 text-center" @click="goToJobPage('MyCanceled')">
          <div class="card-body">
            <h2 class="card-title text-warning">{{ myStats.Canceled }}</h2>
            <p class="card-text">{{ getJobTypeText("MyCanceled") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="myStatsError" class="text-center text-danger">
      {{ myStatsError }}
    </div>
    <div v-else class="text-center text-muted">Yükleniyor...</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    currentAccount() {
      return this.$root.$data.login.Account;
    },
  },
  data() {
    return {
      myStats: null,
      myStatsError: null,
      accounts: null,
      currentAccountId: this.$root.$data.login.Account.Id,
    };
  },
  methods: {
    goToJobPage(pageName) {
      this.$router.push({ name: "Job", hash: "#" + pageName });
    },
    getMyStats() {
      this.myStats = null;
      this.myStatsError = null;

      axios
        .get("/dashboard/myjobs")
        .then((r) => {
          this.myStats = r.data;
        })
        .catch((r) => {
          console.log("MyStatsErr:", r);
          this.myStatsError = "Yüklenemedi.";

          if (r.response && r.response.data.ModelState?.InvalidTokenException) {
            window.processErrorResponse(r, this);
          }
        });
    },

    getAccounts() {
      axios.get("/userAccounts/get").then((x) => {
        if (x.data.Success) {
          this.accounts = x.data.Data;
          //this.currentAccountId = this.$root.$data.login.Account.Id;
        }
      });
    },
    accountChange(accountId) {
      var account = this.accounts.filter((x) => x.Id == accountId)[0];

      console.log("account change:", account, this.currentAccount);

      if (account.Code == this.currentAccount.Code) return;

      //if (!confirm(`${account.Title} hesabına geçiş yapılacak.`)) return;
      this.$izonayConfirm(
        `'${account.Title}' hesabına geçiş yapmak istediğinize emin misiniz?`
      ).then((response) => {
        if (!response.isConfirmed) {
          this.currentAccountId = this.currentAccount.Id;
          return;
        }

        axios
          .post(`/switchaccount/post/${account.Id}`)
          .then((x) => {
            this.errorMessage = null;
            console.log("Gelen sonuç:", x);
            if (x.data.Success) {
              window.localStorage.setItem("user", JSON.stringify(x.data.Data));
              axios.defaults.headers.common["token"] = x.data.Data.Key;
              this.$root.$data.login = x.data.Data;
              this.registerDeviceToken();
              //this.currentAccountId = this.$root.$data.login.Account.Id;
              //this.$router.push("/" + x.data.Data.Account.Code);
              // this.$router.push({ path: "/" + x.data.Data.Account.Code });
              // this.$router.go();
              location.reload()
            } else {
              this.$izonayAlert(x.ErrorMessages);
              this.loading = false;
            }
            console.log(
              "Token geldi: ",
              axios.defaults.headers.common["token"]
            );
          })
          .catch((e) => {
            window.processErrorResponse(e, this);
            this.loading = false;
          });
      });
    },
  },
  created() {
    //this.currentAccount = this.$root.$data.login.Account;
    this.getMyStats();
    this.getAccounts();
    console.log("createed currentAccount: ", this.currentAccount);
    this.currentAccountId = this.$root.$data.login.Account.Id;
  },
};
</script>
<style scoped>
@media (max-width: 767.98px) {
  .card {
    min-height: 125px;
  }
}
</style>
